import React from "react";
import {
  DefaultButton,
  PrimaryButton,
  Stack,
  TextField,
} from "@fluentui/react";
// import { mdiCogs } from "@mdi/js";
import { Formik } from "formik";
import { Loading } from "../../services/Loading";
import {
  addOrUpdateSLAMatrixConfig,
  getSLAMatrixConfig,
} from "../../services/sla-matrix/SlaMatrixService";
import { ISLAMatrix } from "../../vm";
import { childrenGap } from "../common/Constants";
import PageTitle from "../common/PageTitle";
import { ToastContext } from "../common/ToastProvider";
import { ReactComponent as SlaMatrixIcon } from "../../images/sla-matrix.svg";
import { parseJwt } from "../../services/UtilService";

export interface SlaMatrixMainProps {}

const SlaMatrixMain: React.FC<SlaMatrixMainProps> = () => {
  // custom hooks
  const { showToast } = React.useContext(ToastContext);
  const tokenData = parseJwt();

  // state
  const [state, setState] = React.useState({
    isLoading: false,
    slaMatrix: {},
    isEdit: false,
  } as {
    isLoading: boolean;
    slaMatrix: ISLAMatrix;
    isEdit: boolean;
  });

  // hooks
  React.useEffect(() => {
    const asyncFunc = async () => {
      await getSlaMatrix();
    };
    asyncFunc();
  }, []);

  const getSlaMatrix = async () => {
    setState({ ...state, isLoading: true });
    let result = await getSLAMatrixConfig("");
    if (result?.success) {
      setState({
        ...state,
        slaMatrix: result.data || { humidity: {}, temperature: {} },
        isLoading: false,
      });
    } else {
      setState({ ...state, isLoading: false });
      showToast(result?.message || "Error while getting sla matrixes", "error");
    }
  };

  return (
    <React.Fragment>
      {state.isLoading && <Loading />}
      <Stack>
        <Stack.Item>
          <PageTitle
            icon={SlaMatrixIcon}
            title="SLA Matrix"
            description="Configure SLA Matrix"
          />
        </Stack.Item>
      </Stack>
      <br />
      <br />
      <div
        // style={{
        //   width: "40%",
        //   // margin: 'auto',
        // }}
        className="custom-sm-table"
      >
        {/* <Stack tokens={childrenGap}>
          <Stack.Item>
            <Stack horizontal wrap tokens={childrenGap} horizontalAlign='end'>
              {!state.isEdit && (
                <Stack.Item>
                  <DefaultButton
                    text='Edit'
                    onClick={() => setState({ ...state, isEdit: true })}
                  />
                </Stack.Item>
              )}
            </Stack>
          </Stack.Item>
          <Stack.Item> */}
        <React.Fragment>
          <Formik
            enableReinitialize
            initialValues={state.slaMatrix}
            onSubmit={async (values: ISLAMatrix, { setSubmitting }) => {
              let data = { ...values };
              data.customerId = "";
              setState({ ...state, isLoading: true });
              let result = await addOrUpdateSLAMatrixConfig(data);
              if (result?.success) {
                setState({
                  ...state,
                  slaMatrix: result.data,
                  isLoading: false,
                  isEdit: false,
                });
                showToast(
                  "SLA Matrixes config updated successfully",
                  "success"
                );
              } else {
                setState({ ...state, isLoading: false });
                showToast(
                  result?.message || "Error while updating sla matrixes config",
                  "error"
                );
              }
              setSubmitting(false);
            }}
          >
            {({ handleChange, handleBlur, handleSubmit, values }) => (
              <form onSubmit={handleSubmit}>
                <Stack tokens={childrenGap}>
                  <Stack.Item>
                    <Stack horizontal wrap tokens={childrenGap}>
                      {state.isEdit ? (
                        <>
                          <Stack.Item>
                            <PrimaryButton type="submit" text="Save" />
                          </Stack.Item>
                          <Stack.Item>
                            <DefaultButton
                              onClick={() =>
                                setState({ ...state, isEdit: false })
                              }
                              text="Cancel"
                              className="borderless-btn"
                            />
                          </Stack.Item>
                        </>
                      ) : (
                        <Stack.Item>
                          {![4].includes(tokenData.role) && (
                          <PrimaryButton
                            text="Edit"
                            onClick={() => setState({ ...state, isEdit: true })}
                          />
                          )}
                        </Stack.Item>
                      )}
                    </Stack>
                  </Stack.Item>
                  <Stack.Item>
                    <div
                      className="office-table borderless-table"
                      style={{ overflow: "hidden" }}
                    >
                      <table className="ms-Table">
                        <thead className="html-table-thead">
                          <tr style={{ height: 44, fontSize: 14 }}>
                            <th>Description of Service</th>
                            <th>As per SLA</th>
                          </tr>
                        </thead>
                        <tbody style={{ color: "#383737" }}>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#fdfdfd",
                            }}
                          >
                            <td width={140} align="center">
                              Power Uptime
                            </td>
                            {state.isEdit ? (
                              <td width={200}>
                                <TextField
                                  name="powerUptime"
                                  type="number"
                                  value={String(values?.powerUptime)}
                                  suffix="%"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </td>
                            ) : (
                              <td align="center" width={200}>
                                {values?.powerUptime
                                  ? values.powerUptime + "%"
                                  : "0%"}
                              </td>
                            )}
                          </tr>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#f3f3f3",
                            }}
                          >
                            <td width={140} align="center">
                              AC Uptime
                            </td>
                            {state.isEdit ? (
                              <td>
                                <TextField
                                  name="acUptime"
                                  type="number"
                                  value={String(values?.acUptime)}
                                  suffix="%"
                                  onChange={handleChange}
                                  onBlur={handleBlur}
                                />
                              </td>
                            ) : (
                              <td align="center">
                                {values?.acUptime
                                  ? values.acUptime + "%"
                                  : "0%"}
                              </td>
                            )}
                          </tr>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#fdfdfd",
                            }}
                          >
                            <td width={140} align="center">
                              Temperature
                            </td>
                            {state.isEdit ? (
                              <td>
                                <Stack horizontal tokens={childrenGap}>
                                  <Stack.Item grow>
                                    <TextField
                                      name="temperature.min"
                                      type="number"
                                      value={String(values?.temperature?.min)}
                                      suffix="℃"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                  <Stack.Item> to </Stack.Item>
                                  <Stack.Item grow>
                                    <TextField
                                      name="temperature.max"
                                      type="number"
                                      value={String(values?.temperature?.max)}
                                      suffix="℃"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                </Stack>
                              </td>
                            ) : (
                              <td align="center">
                                {values?.temperature?.min
                                  ? values.temperature.min + "℃  to  "
                                  : "0℃ to "}
                                {values?.temperature?.max
                                  ? values?.temperature?.max + "℃"
                                  : "0℃"}
                              </td>
                            )}
                          </tr>
                          <tr
                            style={{
                              height: 44,
                              backgroundColor: "#f3f3f3",
                            }}
                          >
                            <td width={140} align="center">
                              Humidity
                            </td>
                            {state.isEdit ? (
                              <td>
                                <Stack horizontal tokens={childrenGap}>
                                  <Stack.Item grow>
                                    <TextField
                                      name="humidity.min"
                                      type="number"
                                      value={String(values?.humidity?.min)}
                                      suffix="%"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                  <Stack.Item>to</Stack.Item>
                                  <Stack.Item grow>
                                    <TextField
                                      name="humidity.max"
                                      type="number"
                                      value={String(values?.humidity?.max)}
                                      suffix="%"
                                      onChange={handleChange}
                                      onBlur={handleBlur}
                                    />
                                  </Stack.Item>
                                </Stack>
                              </td>
                            ) : (
                              <td align="center">
                                {values?.humidity?.min
                                  ? values.humidity.min + "%  to  "
                                  : "0% to "}
                                {values?.humidity?.max
                                  ? values.humidity.max + "%"
                                  : "0%"}
                              </td>
                            )}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </Stack.Item>
                  {/* {state.isEdit && (
                    <Stack.Item>
                      <Stack
                        horizontal
                        wrap
                        tokens={childrenGap}
                        horizontalAlign="end"
                      >
                        <Stack.Item>
                          <DefaultButton
                            onClick={() =>
                              setState({ ...state, isEdit: false })
                            }
                            text="Cancel"
                          />
                        </Stack.Item>
                        <Stack.Item>
                          <PrimaryButton type="submit" text="Save" />
                        </Stack.Item>
                      </Stack>
                    </Stack.Item>
                  )} */}
                </Stack>
              </form>
            )}
          </Formik>
        </React.Fragment>
        {/* </Stack.Item>
        </Stack> */}
      </div>
    </React.Fragment>
  );
};

export default SlaMatrixMain;
